import { jsx } from "react/jsx-runtime";
import { createContext, useState } from "react";
const ModalContext = createContext(void 0);
const ModalProvider = ({ children }) => {
  const [showCloseWarning, setShowCloseWarning] = useState(false);
  const enableCloseWarning = () => setShowCloseWarning(true);
  const disableCloseWarning = () => setShowCloseWarning(false);
  return /* @__PURE__ */ jsx(ModalContext.Provider, { value: { showCloseWarning, enableCloseWarning, disableCloseWarning }, children });
};
export {
  ModalContext,
  ModalProvider
};
